export const LIB_VERSION = "0.1.2";
//# sourceMappingURL=version.js.map